(() => {
  const ROOT = document.documentElement;
  const MOBILE_QUERY = window.matchMedia('(max-width: 1199px)');
  let observedBar = null;
  let resizeObserver = null;

  const setOffset = (height) => {
    if (!MOBILE_QUERY.matches) {
      ROOT.style.removeProperty('--cdo-announcement-offset');
      return;
    }

    ROOT.style.setProperty(
      '--cdo-announcement-offset',
      `${Math.max(0, Math.round(height || 0))}px`
    );
  };

  const getEntryHeight = (entry) => {
    if (!entry || !entry.target || entry.target.hidden) return 0;

    const borderBox = entry.borderBoxSize;
    if (borderBox) {
      const size = Array.isArray(borderBox) ? borderBox[0] : borderBox;
      if (size && Number.isFinite(size.blockSize)) return size.blockSize;
    }

    return entry.contentRect ? entry.contentRect.height : entry.target.offsetHeight;
  };

  const updateFromBar = () => {
    if (!MOBILE_QUERY.matches) {
      ROOT.style.removeProperty('--cdo-announcement-offset');
      return;
    }

    setOffset(observedBar && !observedBar.hidden ? observedBar.offsetHeight : 0);
  };

  const disconnectObserver = () => {
    if (resizeObserver) resizeObserver.disconnect();
    resizeObserver = null;
    observedBar = null;
  };

  const bindAnnouncementBar = () => {
    const nextBar = document.querySelector('cardology-announcement-bar');

    if (nextBar === observedBar) {
      updateFromBar();
      return;
    }

    disconnectObserver();
    observedBar = nextBar;

    if (!observedBar) {
      setOffset(0);
      return;
    }

    if ('ResizeObserver' in window) {
      resizeObserver = new ResizeObserver((entries) => {
        const entry = entries[0];
        setOffset(getEntryHeight(entry));
      });
      resizeObserver.observe(observedBar);
    }

    updateFromBar();
  };

  const handleBreakpointChange = () => {
    if (MOBILE_QUERY.matches) {
      bindAnnouncementBar();
    } else {
      ROOT.style.removeProperty('--cdo-announcement-offset');
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindAnnouncementBar, { once: true });
  } else {
    bindAnnouncementBar();
  }

  if (typeof MOBILE_QUERY.addEventListener === 'function') {
    MOBILE_QUERY.addEventListener('change', handleBreakpointChange);
  } else if (typeof MOBILE_QUERY.addListener === 'function') {
    MOBILE_QUERY.addListener(handleBreakpointChange);
  }

  document.addEventListener('shopify:section:load', bindAnnouncementBar);
  document.addEventListener('shopify:section:unload', () => {
    window.requestAnimationFrame(bindAnnouncementBar);
  });
})();
